var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeveloperRelations = function SvgDeveloperRelations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.652.41A8.7 8.7 0 0 1 24.71.117c1.36.21 2.649.741 3.758 1.547a8.5 8.5 0 0 1 2.614 3.086 8.5 8.5 0 0 1 .806 5.214 8.54 8.54 0 0 1-2.433 4.694l-.711.734a2 2 0 0 1-1.436.608H16c-2.21 0-4 1.896-4 4.235v2.944a.5.5 0 0 1-.86.348L2.53 14.64A8.53 8.53 0 0 1 .11 9.952 8.5 8.5 0 0 1 .92 4.75a8.6 8.6 0 0 1 2.62-3.075A8.7 8.7 0 0 1 7.291.118a8.8 8.8 0 0 1 4.056.304 8.7 8.7 0 0 1 3.47 2.098l1.184 1.171 1.186-1.17A8.6 8.6 0 0 1 20.652.41",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 20a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2zm10.47 1.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06L26.94 25l-2.47-2.47a.75.75 0 0 1 0-1.06m-2.94 1.06a.75.75 0 1 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 1 0 1.06-1.06L19.06 25z",
    clipRule: "evenodd"
  })));
};
export default SvgDeveloperRelations;